import { createFileRoute } from '@tanstack/react-router';

import { exigirAcceso } from '@/entities/usuario';
import { UsuarioDetailPage } from '@/pages/usuario-detail';

export const Route = createFileRoute('/_private/usuarios/$id')({
  beforeLoad: () => exigirAcceso('usuarios'),
  component: UsuarioDetailPage,
});
